import ProtectiveEquipment from "../../../permits/conditions/ProtectiveEquipment";
import FormElement, { formElement } from "../../FormElement";
import GasWarnerFormState from "./GasWarnerFormState";

type ProtectiveEquipmentFormState = {
    usingLifeJacket: FormElement<boolean>;
    usingHelmet: FormElement<boolean>;
    usingProtectiveGlasses: FormElement<boolean>;
    gasWarner: GasWarnerFormState;
    usingGasMask: FormElement<boolean>;
    usingFreshAirMask: FormElement<boolean>;
    other: FormElement<string>;
};

export default ProtectiveEquipmentFormState;

export function ProtectiveEquipmentFormState_fromFormState(
    protectiveEquipment: ProtectiveEquipmentFormState
): ProtectiveEquipment {
    return {
        usingLifeJacket: protectiveEquipment.usingLifeJacket.value,
        usingHelmet: protectiveEquipment.usingHelmet.value,
        usingProtectiveGlasses: protectiveEquipment.usingProtectiveGlasses.value,
        gasWarner: {
            forH2S: protectiveEquipment.gasWarner.forH2S.value,
            forLEL: protectiveEquipment.gasWarner.forLEL.value,
            forO2: protectiveEquipment.gasWarner.forO2.value,
            personalGasWarner: protectiveEquipment.gasWarner.personalGasWarner.value
        },
        usingGasMask: protectiveEquipment.usingGasMask.value,
        usingFreshAirMask: protectiveEquipment.usingFreshAirMask.value,
        other: protectiveEquipment.other.value
    };
}

export function ProtectiveEquipmentFormState_default(): ProtectiveEquipmentFormState {
    return {
        usingLifeJacket: formElement(false),
        usingHelmet: formElement(true),
        usingProtectiveGlasses: formElement(true),
        gasWarner: {
            forH2S: formElement(false),
            forLEL: formElement(false),
            forO2: formElement(false),
            personalGasWarner: formElement(false)
        },
        usingGasMask: formElement(false),
        usingFreshAirMask: formElement(false),
        other: formElement("")
    };
}